var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-message',{staticClass:"AMessage",attrs:{"type":_vm.type}},[(_vm.canClose)?_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.closeMessageEvent}},[_c('x-icon',{attrs:{"size":"2x"}})],1):_vm._e(),_c('p',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }